import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import api from "@/lib/api";
import { cityPath } from "@/lib/seo";

let cache = null;

export function useCities() {
    const [cities, setCities] = useState(cache || []);
    useEffect(() => {
        if (cache) return;
        api.get("/geo/cities").then((r) => { cache = r.data.items || []; setCities(cache); }).catch(() => {});
    }, []);
    return cities;
}

// Chip neumorphic "Esplora per città" — riusato in catalogo, pagina città e footer.
export default function CityLinks({ variant = "chips", exclude, limit = 12, cities: given }) {
    const fetched = useCities();
    const cities = (given || fetched).filter((c) => c.slug !== exclude).slice(0, limit);
    if (!cities.length) return null;

    if (variant === "footer") {
        return (
            <ul data-testid="footer-city-links" className="space-y-3 text-sm text-ink-100">
                {cities.slice(0, 6).map((c) => (
                    <li key={c.slug}><a href={cityPath(c.slug)} className="hover:text-gold transition-colors">Case a {c.city}</a></li>
                ))}
            </ul>
        );
    }

    return (
        <div data-testid="city-links" className="flex flex-wrap gap-3">
            {cities.map((c) => (
                <Link
                    key={c.slug}
                    to={cityPath(c.slug)}
                    data-testid={`city-link-${c.slug}`}
                    className="neu-btn inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium"
                >
                    <MapPin size={14} className="text-blue-600" />
                    {c.city}
                    <span className="text-[11px] text-blue-700/70 font-semibold">{c.count}</span>
                </Link>
            ))}
        </div>
    );
}
